var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpencloudwareinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 66,
    viewBox: "0 0 98 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.283 21.94h3.657M5.12 32.91h3.656M19.016 44.612h3.656M30.717 56.314h3.657M16.09 32.91h55.582M29.984 44.612h40.224M29.254 21.94h7.313v-.73c0-8.483 7.04-15.359 15.724-15.359 8.684 0 15.724 6.876 15.724 15.358h4.388c9.694 0 17.552 7.859 17.552 17.552 0 9.694-7.858 17.553-17.552 17.553H41.687",
    stroke: "#000",
    strokeWidth: 5.851,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgOpencloudwareinline;